<template>
<div class="chapter">
<div class="inner_page">
<p class="praise1"><a id="page_ii">“ANYONE WHO LOVES ROMANCE MUST READ SABRINA JEFFRIES! ”</a></p><a id="page_ii">
<p class="att1">—<span class="txit">New York Times</span> bestselling author Lisa Kleypas</p>
<p class="praisec"><span class="txbf">The Sinful Suitors</span></p>
<p class="praises"><span class="txbf">Sabrina Jeffries’s delightful Regency series featuring the St. George’s Club, where watchful guardians conspire to keep their unattached sisters and wards out of the clutches of sinful suitors.</span></p>
<p class="praised"><span class="txbfit">THE ART OF SINNING</span></p>
<p class="noindent">“With every book, Jeffries grows into an even more accomplished writer whose memorable characters and unforgettable stories speak to readers on many levels.”</p>
<p class="att">—<span class="txit">RT Book Reviews</span> (4<sup class="sup">1</sup>/<sub class="sub">2</sub> stars, Top Pick)</p>
<p class="noindent">“Veteran historical romance author Jeffries launches her Sinful Suitors Regency series with two effortlessly crafted charismatic protagonists.”</p>
<p class="att">—<span class="txit">Publishers Weekly</span></p>
<p class="noindent">“<span class="txit">The Art of Sinning</span> is an endearing beginning to a new series, and showcases Jeffries’s talents in making the reader swoon in delight.”</p>
<p class="att">—<span class="txit">Fresh Fiction</span></p>
<p class="praisec1"><span class="txbf">Also from</span> <span class="txbfit">New York Times</span> <span class="txbf">and</span> <span class="txbfit">USA Today</span> <span class="txbf">bestselling author SABRINA JEFFRIES</span></p>
<p class="praisec"><span class="txbf">The Duke’s Men</span></p>
<p class="praises"><span class="txbf">They are an investigative agency born out of family pride and irresistible passion . . . and they risk their lives and hearts to unravel any shocking deception or scandalous transgression!</span></p>
<p class="praised"><span class="txbfit">IF THE VISCOUNT FALLS</span></p>
<p class="noindent">“Jeffries’s addictive series satisfies.“</p>
<p class="att">—<span class="txit">Library Journal</span></p>
</a><p class="praised"><a id="page_ii"></a><a id="page_iii"><span class="txbfit">HOW THE SCOUNDREL SEDUCES</span></a></p><a id="page_iii">
<p class="noindent">“Scorching . . . From cover to cover, it sizzles.”</p>
<p class="att">—<span class="txit">Reader to Reader</span></p>
<p class="noindent">“Marvelous storytelling . . . Memorable.”</p>
<p class="att">—<span class="txit">RT Book Reviews</span> (4<sup class="sup">1</sup>/<sub class="sub">2</sub> stars, Top Pick, K.I.S.S. Award)</p>
<p class="praised"><span class="txbfit">WHEN THE ROGUE RETURNS</span></p>
<p class="noindent">“Blends the pace of a thriller with the romance of the Regency era.”</p>
<p class="att">—<span class="txit">Woman’s Day</span></p>
<p class="noindent">“Enthralling . . . rich in passion and danger.”</p>
<p class="att">—<span class="txit">Booklist</span> (starred review)</p>
<p class="praised"><span class="txbfit">WHAT THE DUKE DESIRES</span></p>
<p class="noindent">“A totally engaging, adventurous love story with an oh-so-wonderful ending.”</p>
<p class="att">—<span class="txit">RT Book Reviews</span></p>
<p class="noindent">“Full of all the intriguing characters, brisk plotting, and witty dialogue that Jeffries’s readers have come to expect.”</p>
<p class="att">—<span class="txit">Publishers Weekly</span> (starred review)</p>
<p class="praisec1"><span class="txbf">The</span> <span class="txbfit">New York Times</span> <span class="txbf">bestselling</span> <span class="txbf">“must-read series” (</span><span class="txbfit">Romance Reviews Today</span><span class="txbf">)</span></p>
<p class="praisec2"><span class="txbf">The Hellions of Halstead Hall</span></p>
<p class="praised"><span class="txbfit">A LADY NEVER SURRENDERS</span></p>
<p class="noindent">“Jeffries pulls out all the stops . . . Not to be missed.”</p>
<p class="att">—<span class="txit">RT Book Reviews</span> (4<sup class="sup">1</sup>/<sub class="sub">2</sub> stars, Top Pick)</p>
<p class="noindent">“Sizzling, emotionally satisfying . . . Another must-read.”</p>
<p class="att">—<span class="txit">Library Journal</span> (starred review)</p>
</a><p class="noindent"><a id="page_iii"></a><a id="page_iv">“<span class="txit">A Lady Never Surrenders</span> wraps up the series nothing short of brilliantly.”</a></p><a id="page_iv">
<p class="att">—<span class="txit">Booklist</span></p>
<p class="praised"><span class="txbfit">TO WED A WILD LORD</span></p>
<p class="noindent">“Wonderfully witty, deliciously seductive, graced with humor and charm.”</p>
<p class="att">—<span class="txit">Library Journal</span> (starred review)</p>
<p class="noindent">“A beguiling blend of captivating characters, clever plotting, and sizzling sensuality.”</p>
<p class="att">—<span class="txit">Booklist</span></p>
<p class="praised"><span class="txbfit">HOW TO WOO A RELUCTANT LADY</span></p>
<p class="noindent">“Delightful . . . Charmingly original.”</p>
<p class="att">—<span class="txit">Publishers Weekly</span> (starred review)</p>
<p class="noindent">“Steamy passion, dangerous intrigue, and just the right amount of tart wit.”</p>
<p class="att">—<span class="txit">Booklist</span></p>
<p class="praised"><span class="txbfit">A HELLION IN HER BED</span></p>
<p class="noindent">“Jeffries’s sense of humor and delightfully delicious sensuality spice things up! ”</p>
<p class="att">—<span class="txit">RT Book Reviews</span> (4<sup class="sup">1</sup>/<sub class="sub">2</sub> stars)</p>
<p class="praised"><span class="txbfit">THE TRUTH ABOUT LORD STONEVILLE</span></p>
<p class="noindent">“Jeffries combines her hallmark humor, poignancy, and sensuality to perfection.”</p>
<p class="att">—<span class="txit">RT Book Reviews</span> (4<sup class="sup">1</sup>/<sub class="sub">2</sub> stars, Top Pick)</p>
<p class="noindent">“Delectably witty dialogue . . . and scorching sexual chemistry.”</p>
<p class="attb">—<span class="txit">Booklist</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?346ad3d4